// AllAware Play — spectator SPA entry. Static build for Cloudflare Pages
// (no 404.html, so Pages' SPA mode serves index.html for every route); talks only to the play
// Convex deployment (VITE_CONVEX_URL).
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { App } from './App';
import { CONVEX_URL } from './env';
import { applyStoredTheme } from './lib/theme';
import './styles.css';

applyStoredTheme();

const root = createRoot(document.getElementById('root')!);

if (!CONVEX_URL) {
  root.render(
    <main className="boot-error">
      <h1>AllAware Play</h1>
      <p>
        This build has no <code>VITE_CONVEX_URL</code>. Set it to the play deployment URL and rebuild.
      </p>
    </main>,
  );
} else {
  const convex = new ConvexReactClient(CONVEX_URL);
  root.render(
    <StrictMode>
      <ConvexProvider client={convex}>
        <App />
      </ConvexProvider>
    </StrictMode>,
  );
}
